namespace PaperTrail.NewsletterControl {
    export interface NewsletterUserRow {
        NewsletterUserId?: number;
        NewsletterId?: number;
        UserId?: number;
        NewsletterNewsletterName?: string;
        NewsletterCreatedBy?: number;
        NewsletterDateCreated?: string;
        NewsletterDateModified?: string;
        NewsletterModifiedBy?: number;
        NewsletterPageCount?: number;
        NewsletterStyleSheetId?: number;
        UserUsername?: string;
        UserDisplayName?: string;
        UserEmail?: string;
        UserSource?: string;
        UserLastDirectoryUpdate?: string;
        UserUserImage?: string;
        UserInsertDate?: string;
        UserInsertUserId?: number;
        UserUpdateDate?: string;
        UserUpdateUserId?: number;
        UserIsActive?: number;
        UserMobilePhoneNumber?: string;
        UserMobilePhoneVerified?: boolean;
        UserTwoFactorAuth?: number;
    }

    export namespace NewsletterUserRow {
        export const idProperty = 'NewsletterUserId';
        export const localTextPrefix = 'NewsletterControl.NewsletterUser';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Newsletter:Contributor';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            NewsletterUserId = "NewsletterUserId",
            NewsletterId = "NewsletterId",
            UserId = "UserId",
            NewsletterNewsletterName = "NewsletterNewsletterName",
            NewsletterCreatedBy = "NewsletterCreatedBy",
            NewsletterDateCreated = "NewsletterDateCreated",
            NewsletterDateModified = "NewsletterDateModified",
            NewsletterModifiedBy = "NewsletterModifiedBy",
            NewsletterPageCount = "NewsletterPageCount",
            NewsletterStyleSheetId = "NewsletterStyleSheetId",
            UserUsername = "UserUsername",
            UserDisplayName = "UserDisplayName",
            UserEmail = "UserEmail",
            UserSource = "UserSource",
            UserLastDirectoryUpdate = "UserLastDirectoryUpdate",
            UserUserImage = "UserUserImage",
            UserInsertDate = "UserInsertDate",
            UserInsertUserId = "UserInsertUserId",
            UserUpdateDate = "UserUpdateDate",
            UserUpdateUserId = "UserUpdateUserId",
            UserIsActive = "UserIsActive",
            UserMobilePhoneNumber = "UserMobilePhoneNumber",
            UserMobilePhoneVerified = "UserMobilePhoneVerified",
            UserTwoFactorAuth = "UserTwoFactorAuth"
        }
    }
}
